<div class="wrapper">
  <app-header-view />
  <div class="main">
    <router-outlet></router-outlet>
  </div>
  <app-footer />
</div>
